<template>
  <v-card>
    <v-card-title>
      <b>Domains</b>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        v-if="!creating"
        class="float-sm-right mt-2 mx-2"
        @click="$emit('createReq')"
      >
        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-list>
        <Alert v-if="showAlert" text="Domain updated" type="success" />
        <v-list-item
          v-for="(domain, index) in domainsData"
          :key="domain.id"
          class="card-shadow border-radius-xl p-2"
        >
          <v-list-item-content>
            <v-row>
              <v-col cols="8">
                <EditableField
                  class="mt-2"
                  :value="domain.url"
                  :keyPath="`domainsData.${index}.url`"
                  label="URL"
                  hideLabel
                  :editing="editing[index]"
                  @save="updateApiData"
                >
                  <template #value>
                    <a
                      :href="'https://' + domain.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-decoration-none"
                    >
                      <span class="text-truncate">{{ domain.url }}</span>
                    </a>
                  </template>
                </EditableField>
              </v-col>
              <v-col cols="4">
                <v-btn
                  icon
                  small
                  v-if="!editing[index]"
                  @click="deleteDomain(index)"
                  class="float-sm-right mt-2 mx-2"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="float-sm-right mt-2 mx-2"
                  @click="toggleEdit(index)"
                >
                  <v-icon small>{{
                    editing[index] ? 'mdi-content-save' : 'mdi-pencil'
                  }}</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  v-if="editing[index]"
                  @click="cancelEdit(index)"
                  class="btn-sm float-sm-right mt-2 mx-2"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import Alert from '@/components/Alert.vue'
  import EditableField from '../../components/EditableField.vue'
  import { setNestedValue } from '@/util/helpers.js'

  export default {
    name: 'ClientDomains',
    components: { EditableField, Alert },
    props: {
      domains: {
        type: Array,
        default: () => [],
        required: true,
      },
      creating: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editing: [],
        domainsData: this.domains,
        showAlert: false,
      }
    },
    methods: {
      toggleEdit(index) {
        if (this.editing[index]) {
          this.updateDomain(index)
        }
        this.$set(this.editing, index, !this.editing[index])
      },
      updateApiData(details) {
        setNestedValue(this, details.keyPath, details.value)
      },
      updateDomain(index) {
        setTimeout(() => {
          console.log(this.domainsData)
          let details = { ...this.domainsData[index] }
          let domainId = details['id']
          for (let key of [
            'created_at',
            'updated_at',
            'deleted_at',
            'client_id',
            'id',
          ])
            delete details[key]
          this.apiModifyClientDomain(domainId, details)
            .then(response => {
              this.domainsData[index] = response
              this.showAlert = true
            })
            .catch(error => {
              console.log(error)
            })
        }, 200)
      },
      cancelEdit(index) {
        this.domainsData[index] = { ...this.domains[index] }
        this.$set(this.editing, index, false)
      },
      deleteDomain(index) {
        let domainId = this.domainsData[index].id
        this.apiDeleteClientDomain(domainId)
          .then(() => {
            this.domainsData.splice(index, 1)
            this.editing.splice(index, 1)
            this.showAlert = true
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    watch: {
      domains: {
        handler(newDomains) {
          this.editing = newDomains.map(() => false)
          this.domainsData = newDomains
        },
        immediate: true,
      },
    },
  }
</script>
